import React from 'react';
import Title from '../layout/Title';
import { projectOne, projectTwo, projectThree } from "../../assests/index";
import ProjectsCard from './ProjectCard';
import { Link } from 'react-router-dom';

const Projects = () => {
  return (
    <section id="projects" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 xl:gap-14">
        <ProjectsCard
          title="Creative Graphic Designer"
          des="Creative graphic designer with expertise in branding and visual communication, delivering impactful and innovative designs that resonate with audiences."
          src={projectOne}
        />
        {/* Second card - navigate to the video gallery on click */}
        <Link to="/video-gallery">
          <ProjectsCard
            title="Animation Video Clip"
            des="Dynamic and engaging animation videos designed to capture attention and communicate your message effectively through vibrant visuals and smooth transitions."
            src={projectTwo}
          />
        </Link>
      </div>
    </section>
  );
};

export default Projects;
